import { Centred, Contents } from '../../styles/mixins'
import { RichText } from '../../styles/mixins'

const styles = theme => ({
  centred: {
    ...Centred(theme)
  },
  contents: {
    ...Contents(theme)
  },
  strap: {
    marginTop: theme.spacing.unit * 10,
    height: '50vh',
  },
  subtitle: {
    fontSize: theme.typography.body2.fontSize,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.caption.fontSize,
    },
  },
  title: {
    fontSize: theme.typography.display1.fontSize,
    textTransform: 'uppercase',
    fontWeight: 800,
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.headline.fontSize,
    },
  },
  share: {
    float: 'right'
  },

})

export default styles



// WEBPACK FOOTER //
// ./src/components/strap/styles.js